<script setup lang="ts">
import { IconChevronUp } from '@tabler/icons-vue'
import { watch } from 'vue'

import BaseButton from '@tix/ds/components/atoms/BaseButton.vue'

import type { SelectionSummaryProps } from '@/components/bundles/selections/SelectionSummary.vue'
import {
  type SelectionsModalContent,
  openSelectionsModal,
  updateSelectionsModal,
} from '@/components/bundles/selections/openSelectionsModal'
import PriceDisplay from '@/components/elements/PriceDisplay.vue'

export type SelectionsTriggerProps = Pick<SelectionSummaryProps, 'rows' | 'subtotal'> & {
  label?: string
}

const props = withDefaults(defineProps<SelectionsTriggerProps>(), {
  label: 'Order Subtotal',
})

const emit = defineEmits<{
  edit: [resolverId: string, type?: string]
}>()

function content(): SelectionsModalContent {
  return { rows: props.rows, subtotal: props.subtotal }
}

function onEdit(resolverId: string, type?: string) {
  emit('edit', resolverId, type)
}

function open() {
  openSelectionsModal({ ...content(), onEdit })
}

// The sheet holds a copy of these, so a flow step that resolves while it is open has to be pushed in.
watch(content, () => updateSelectionsModal(content(), onEdit))
</script>

<template>
  <BaseButton class="selections-trigger" hierarchy="tertiary" :iconAfter="IconChevronUp" @click="open">
    {{ label }}
    <PriceDisplay v-if="props.subtotal != undefined" :value="props.subtotal" />
  </BaseButton>
</template>

<style scoped>
.selections-trigger {
  width: 100%;
}
</style>
